(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmb-d8d57ad26d"] && !Shopify.designMode) return;
  try {
    
function initializeResourceFilters(root=document){root.querySelectorAll('.resource-index').forEach(section=>{if(section.dataset.filtersReady)return;const controls=section.querySelector('.resource-filters');if(!controls)return;section.dataset.filtersReady='true';controls.hidden=false;const cards=[...section.querySelectorAll('.resource-card')];const status=section.querySelector('.resource-filter-status');status.textContent=cards.length+' resources';controls.addEventListener('click',event=>{const button=event.target.closest('[data-resource-filter]');if(!button)return;const topic=button.dataset.resourceFilter;controls.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));let count=0;cards.forEach(card=>{card.hidden=topic!=='all'&&card.dataset.category!==topic;if(!card.hidden)count++;});status.textContent=count+' resources'+(topic==='all'?'':' in '+button.textContent);});});}
initializeResourceFilters();document.addEventListener('shopify:section:load',event=>initializeResourceFilters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmb-v9-cred-benefits"] && !Shopify.designMode) return;
  try {
    
(() => {
  const updateOverlap = () => {
    document.querySelectorAll('.cred-benefits-section .cred-overview').forEach(card => {
      const section = card.closest('.shopify-section');
      const previous = section?.previousElementSibling;
      const hero = previous?.querySelector('.cred-hero');
      const visible = hero && !previous.hidden && !hero.hidden && getComputedStyle(previous).display !== 'none' && getComputedStyle(hero).display !== 'none' && getComputedStyle(previous).visibility !== 'hidden' && getComputedStyle(hero).visibility !== 'hidden';
      card.dataset.credOverlap = visible ? 'true' : 'false';
    });
  };
  let frame;
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(updateOverlap);
  };
  const initialize = () => {
    updateOverlap();
    if (window.Shopify?.designMode) {
      ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(event => document.addEventListener(event, schedule));
      const main = document.getElementById('main');
      if (main) new MutationObserver(schedule).observe(main, {childList:true, subtree:true, attributes:true, attributeFilter:['hidden', 'style']});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})();

  } catch(e) { console.error(e); }
})();
})();
